"use strict";
//var _ = require('lodash');
function cleanOutLinksAndComponents(o) {
}
function findAllComponentsFromTransforms(allComponents, allLinks, allTransforms, tiledata, transform) {
    function handleTransform(t) {
        allTransforms.push(t);
        if (!t.cid) {
            // its a scene, probably
            return;
        }
        var component = tiledata.components.filter(function (c) {
            return c.id === t.cid;
        })[0];
        if (!component) {
            console.log('transform', transform.id, 'does not have any features!');
            return;
        }
        var _a = getComponentsAndLinks(tiledata, component), links = _a.links, components = _a.components;
        allComponents.push(component);
        components.forEach(function (c) {
            allComponents.push(c);
        });
        links.forEach(function (l) {
            allLinks.push(l);
        });
    }
    ((transform.children || []).concat(transform.transforms || [])).forEach(findAllComponentsFromTransforms.bind(null, allComponents, allLinks, allTransforms, tiledata));
    handleTransform(transform);
}
function getComponentsAndLinks(tiledata, fromComponent) {
    var newComponent = fromComponent;
    // link all 
    var components = getAllComponentsFrom(tiledata, fromComponent);
    var links = getAllLinksFrom(tiledata, fromComponent);
    components = _.uniq([fromComponent].concat(components), function (x) {
        return x.id;
    });
    return {
        components: components,
        links: links,
        fromComponent: components[0]
    };
}
function getAllComponentsFrom(tiledata, component, depth, visitedData, parent) {
    if (depth === void 0) { depth = 0; }
    if (visitedData === void 0) { visitedData = {}; }
    if (parent === void 0) { parent = null; }
    if (!component) {
        console.log('broken component', component);
        return [];
    }
    if (visitedData[component.id]) {
        // already visited
        return [];
    }
    var linkedFromComponent = tiledata.links.filter(function (l) {
        return l.source === component.id;
    }).map(function (c) {
        return c.target;
    });
    visitedData[component.id] = true;
    //component.depth = depth;
    //component.parent = parent;
    //component.isPrefab = _.includes(['prefab', 'multiple'], component.type);
    var components = _.compact(linkedFromComponent.map(function (x) {
        return tiledata.components.filter(function (y) {
            return x === y.id;
        })[0];
    }));
    var children = components.map(function (c) {
        var is = _.includes(['prefab', 'multiple'], component.type);
        return getAllComponentsFrom(tiledata, c, depth + 1, visitedData, parent ? parent : (component.isPrefab ? component : null));
    });
    return _.flatten([component].concat(components).concat(children));
}
function getAllLinksFrom(tiledata, component, depth, visitedData, parent) {
    if (depth === void 0) { depth = 0; }
    if (visitedData === void 0) { visitedData = {}; }
    if (parent === void 0) { parent = null; }
    if (!component) {
        console.log('broken component', component);
        return [];
    }
    if (visitedData[component.id]) {
        // already visited
        return [];
    }
    var linkedFromComponent = tiledata.links.filter(function (l) {
        return l.source === component.id;
    });
    visitedData[component.id] = true;
    //component.depth = depth;
    //component.parent = parent;
    //component.isPrefab = _.includes(['prefab', 'multiple'], component.type);
    var childrenLinks = linkedFromComponent.map(function (c) {
        return getAllLinksFrom(tiledata, { id: c.target }, depth + 1, visitedData, parent ? parent : (component.isPrefab ? component : null));
    });
    return _.flatten([].concat(linkedFromComponent).concat(childrenLinks));
}
function findFeatures(features, tiledata, components) {
    components.forEach(function (c) {
        if (c.fid) {
            console.log('fffff', c.fid);
            features.push(tiledata.features.filter(function (f) {
                return f.id === c.fid;
            })[0]);
        }
    });
}
function findToys(toys, tiledata, components) {
    components.forEach(function (c) {
        if (c.tid) {
            toys.push(tiledata.toybox.filter(function (t) {
                return c.tid === t.id;
            })[0]);
        }
    });
}
module.exports.getAllLinksFrom = getAllLinksFrom;
module.exports.getAllComponentsFrom = getAllComponentsFrom;
module.exports.getComponentsAndLinks = getComponentsAndLinks;
module.exports.findAllComponentsFromTransforms = findAllComponentsFromTransforms;
module.exports.findFeatures = findFeatures;
module.exports.findToys = findToys;
